import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { env } from '@/lib/env';

// Log environment configuration (dev only)
if (env.isDev) {
  console.log('🚀 Frontend Environment:', {
    ENV: env.ENV,
    AUTH_MODE: env.AUTH_MODE,
    API_URL: env.API_URL,
    API_BASE_URL: env.API_BASE_URL,
    MODE: import.meta.env.MODE,
    runtimeConfig: window.__ENV__,
  });
}

// CI/CD Pipeline Test - Trigger image rebuild

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);